import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import 'slick-carousel';
import 'jquery.cookie';
import 'jquery-inview';

require('./module/_header');
require('./module/_footer');

require('./base/_util');
require('./page/_faq');
require('./page/_member');
require('./page/_member-image');
require('./page/_single-program');
require('./page/_single-lesson');
require('./page/_myprogram');
require('./page/_shindan');
require('./page/_top');
require('./page/_lp');
